import oddsFeatureImage from 'assets/images/odds-feature.webp';
import { Link } from 'react-router-dom';
import { APP_URL } from 'shared/constants/common';
import { BannerSliderEvents } from 'shared/constants/datalayer';
import { BottomPlacementData } from 'shared/types/cms';
import { formatDate, isMobile } from 'shared/util/utility';
import './styles.scss';

interface BottomPlacementContentProps {
	dataBottomBanner: BottomPlacementData;
	fullWidth: boolean;
}

const BottomPlacementContent = ({ dataBottomBanner, fullWidth }: BottomPlacementContentProps) => {
	const imgSrc = isMobile() && dataBottomBanner.imageUrlMobile ? dataBottomBanner.imageUrlMobile : dataBottomBanner.imageUrl || oddsFeatureImage;

	return (
		<div className={`BottomPlacementContent ${fullWidth ? 'width--full' : ''}`}>
			<img
				className="BottomPlacementContent__image"
				src={imgSrc}
				alt={dataBottomBanner.imageAltText || dataBottomBanner.title}
				loading="lazy"
			/>
			<div className="event-details">
				<div className="event-header">
					<div className="event-name">
						<div>{dataBottomBanner.title}</div>
					</div>
					<span className="event-time">{formatDate(dataBottomBanner.dateTill, 'DD.MM.YYYY HH:mm')}</span>
				</div>
				<div className="event-description truncate--lines-3">{dataBottomBanner.subTitle}</div>
			</div>
		</div>
	);
};

const BottomPlacementCard = ({ dataBottomBanner, fullWidth }: BottomPlacementContentProps) => {
	const updateDatalayer = () => {
		if (dataBottomBanner.link === APP_URL.register) {
			BannerSliderEvents.NOT_LOGGED_CLICK_BANNER({});
		}
	};

	return (
		<>
			{dataBottomBanner.link && (
				<Link to={dataBottomBanner.link} onClick={updateDatalayer}>
					<BottomPlacementContent dataBottomBanner={dataBottomBanner} fullWidth={fullWidth} />
				</Link>
			)}
			{!dataBottomBanner.link && <BottomPlacementContent dataBottomBanner={dataBottomBanner} fullWidth={fullWidth} />}
		</>
	);
};

export default BottomPlacementCard;
